import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 180 180",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Property 1=Success",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Error",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Illustration",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Fill-1",
							fillRule: "evenodd",
							clipRule: "evenodd",
							d: "M59.7264 27.9149C69.6214 27.0026 79.1342 29.6387 86.7125 36.214C92.9475 41.6238 97.9893 48.6842 105.483 52.4726C113.466 56.5087 119.312 58.0208 127.838 56.0181C158.928 48.7146 175.543 98.8327 154.706 128.683C133.869 158.533 72.6734 177.65 34.756 126.641C-3.16078 75.6334 16.7307 50.8698 35.4593 37.1347C42.275 32.1361 50.9638 28.7228 59.7264 27.9149Z",
							fill: "#66BB6A",
							fillOpacity: .08
						}),
						/* @__PURE__ */ _jsx("mask", {
							id: "mask0_11110_81212",
							style: { maskType: "alpha" },
							maskUnits: "userSpaceOnUse",
							x: 46,
							y: 37,
							width: 87,
							height: 87,
							children: /* @__PURE__ */ _jsx("circle", {
								id: "Oval",
								cx: 89.2849,
								cy: 80.823,
								r: 42.8386,
								fill: "white"
							})
						}),
						/* @__PURE__ */ _jsx("g", { mask: "url(#mask0_11110_81212)" }),
						/* @__PURE__ */ _jsxs("g", {
							id: "Fill 1 100",
							clipPath: "url(#clip0_11110_81212)",
							children: [/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse 2",
								cx: 146.696,
								cy: 59.3662,
								r: 2,
								fill: "#4CAF50"
							}), /* @__PURE__ */ _jsx("circle", {
								id: "Ellipse 3",
								cx: 34.6963,
								cy: 40.3662,
								r: 3.5,
								stroke: "#4CAF50",
								strokeWidth: 3
							})]
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							id: "Ellipse 4",
							cx: 117.205,
							cy: 28.5841,
							rx: 2.00871,
							ry: 2.01536,
							fill: "#4CAF50"
						}),
						/* @__PURE__ */ _jsx("ellipse", {
							id: "Ellipse 3_2",
							cx: 166.418,
							cy: 95.0911,
							rx: 4.01742,
							ry: 4.03073,
							fill: "#4CAF50"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Ellipse 2_2",
							d: "M21.2951 121.291C21.2951 123.25 19.7137 124.829 17.7734 124.829C15.833 124.829 14.2516 123.25 14.2516 121.291C14.2516 119.332 15.833 117.752 17.7734 117.752C19.7137 117.752 21.2951 119.332 21.2951 121.291Z",
							stroke: "#4CAF50",
							strokeWidth: 3
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Union",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M90 50C63.4428 50 42 71.5857 42 98C42 124.557 63.5857 146 90 146C116.557 146 138 124.414 138 98C138 71.4447 116.555 50 90 50ZM90 137.325C68.3038 137.325 50.6746 119.696 50.6746 98C50.6746 76.3037 68.3038 58.6745 90 58.6745C111.696 58.6745 129.325 76.3037 129.325 98C129.325 119.696 111.696 137.325 90 137.325Z",
					fill: "#4CAF50"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M70.3177 96.541L69.9654 96.1887L69.6119 96.5398L65.6477 100.476L65.2916 100.83L65.6464 101.184L81.2519 116.79L81.6054 117.143L81.959 116.79L115.459 83.2898L115.813 82.9362L115.459 82.5827L111.523 78.6464L111.169 78.2931L110.816 78.6463L81.6056 107.829L70.3177 96.541Z",
					fill: "#4CAF50",
					stroke: "#4CAF50"
				})
			]
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11110_81212",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 125,
			height: 117,
			fill: "white",
			transform: "translate(29.6963 35.3662)"
		})
	}) })]
});
export default SvgSuccessIcon;
